(function ($, window, document, undefined) {
  "use strict";

  /**
   * Creatives page.
   */
  $(function () {

    /**
     * Gallery items sort.
     */
    var galleryElement = document.querySelector( '.creative-page__gallery-items' )
    if ( galleryElement ) {
      window.swanCreativeSwiper = new Swiper( galleryElement, {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 0,
        slideToClickedSlide: true,
        loop: false,
        breakpoints: {
          768: {
            slidesPerView: 2,
            centeredSlides: false,
          },
          1200: {
            slidesPerView: 3,
          },
        },
      } )
    }

    /**
     * Sorting order change.
     */
    $(".creatives-page__orderby select").on("change", function () {
      let $obj = $(this);
      $(".creatives-page__orderby form").submit();
    });
  });

  /**
   * Explore page.
   */
  $(function () {

    /**
     * Explore page products gallery image slides.
     */
    var galleryItems = document.querySelectorAll( '.creative-item__gallery-items' )
    for ( const galleryItem of galleryItems ) {
      window.swanCreativeSwiper = new Swiper( galleryItem, {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
        breakpoints: {
          768: {
            slidesPerView: 'auto',
            centeredSlides: false,
            spaceBetween: 5,
          },
        }
      } )
    }
  });

  $(function () {
    if (
      document.body.classList.contains( 'archive' ) &&
      document.body.classList.contains( 'tax-pa_creative' )
    ) {
    /**
     * After products added.
     */
      speedsearch.hookAFuncAfterThePostsAddition( function() {
        const singleProducts = document.querySelectorAll( '.speedsearch-single-post:not(.single-creative-categories-added)' );

        for ( const singleProduct of singleProducts ) {
          const categoryElem = singleProduct.querySelector( '.category' );

          if ( categoryElem ) {
            categoryElem.innerText = categoryElem.getAttribute( 'data-categories-str' );
          }

          singleProduct.classList.add( 'single-creative-categories-added' );
        }
      } );

      /**
       * When selecting a 'word' ('text' search) on 'creative' tax page, redirect to 'shop' page with that word.
       */
      document.addEventListener(
          'speedsearch_before_posts_request',
          function( e ) {
            const data = e.data.requestParams;

            if (
                data.hasOwnProperty( 'text' ) &&
                data.text
            ) {
              speedsearch.addUrlParam( 'text', data.text, true, false, true );
            }
          },
          { passive: true }
      );
    }

    /**
     * Category archives.
     */
    if (
        document.body.classList.contains( 'tax-product_cat' ) &&
        document.body.classList.contains( 'woocommerce-page' )
    ) {
      /**
       * Filters categories.
       */
      function filterCategories() {
        let categoriesContainersToUse = [];

        const categoriesContainers = document.querySelectorAll( '.speedsearch-categories' );
        for ( const categoriesContainer of categoriesContainers ) {
          if ( ! categoriesContainer.closest( '.speedsearch-mobile-filters-block-container' ) ) {
            categoriesContainersToUse.push( categoriesContainer );
          }
        }

        for ( const categoriesContainer of categoriesContainersToUse ) {

          // Add the class.

          const hasActiveCategories = categoriesContainer.querySelector( '.speedsearch-category:not([style*="display: none;"]):not(.active):not(.child-active)' );

          categoriesContainer.classList.toggle( 'loaded-has-content', hasActiveCategories );

          // Filter the element.

          if ( hasActiveCategories ) {
            const categories = categoriesContainer.querySelectorAll( '.speedsearch-category' );

            for ( const category of categories ) {
              const categoryContainer = category.closest( '.speedsearch-ul-container' );

              if ( categoryContainer ) {
                categoryContainer.classList.toggle(
                    'category-container-hidden',
                    'none' === category.style.display
                );
              }
            }
          }
        }
      }

      /**
       * Add class for categories style rendering.
       */
      document.addEventListener(
          'speedsearch_after_categories_init',
          filterCategories,
          {
            once: true
          }
      );

      /**
       * Open category links in the same page on click.
       */
      document.addEventListener( 'speedsearch_after_first_layer_filtering_finished', filterCategories );
      document.addEventListener( 'speedsearch_after_second_layer_filtering_finished', filterCategories );
      document.addEventListener( 'speedsearch_after_category_change', filterCategories );
      document.addEventListener( 'speedsearch_after_categories_deload_and_then_autoload', filterCategories );

      function debounce( func, wait ) {
        let timeout
        return function () {
          const context = this, args = arguments
          clearTimeout( timeout )
          timeout = setTimeout( () => func.apply( context, args ), wait )
        }
      }

      /**
       * Move categories selector for mobile.
       */
      ( function moveCategoriesSelectorForMobile() {
        const filtersColumn = document.querySelector( '.speedsearch-filters-column' );

        // Only present on SpeedSearch archive/shop pages with the filters sidebar.
        if ( ! filtersColumn ) {
          return;
        }

        const breadcrumbs = document.querySelector( '#breadcrumbs' );
        const filtersCategories = filtersColumn.querySelector( '.speedsearch-categories' );
        const filtersBlock      = filtersColumn.querySelector( '.speedsearch-filters-block' );

        function moveCategories() {

          if ( window.innerWidth <= 850 ) {
            breadcrumbs.parentNode.insertAdjacentElement( 'beforeend' , filtersCategories );
          } else {
            filtersColumn.insertBefore( filtersCategories, filtersBlock );
          }
        }

        /**
         * Init only after the categories are initialized.
         */
        if ( speedsearch.hasOwnProperty( 'categoriesInitialized' ) && speedsearch.categoriesInitialized ) {
          moveCategories();
        } else {
          document.addEventListener( 'speedsearch_after_categories_init', moveCategories, { 'once': true } );
        }

        // Add a resize event listener with debounce.
        window.addEventListener( 'resize', debounce( moveCategories, 100 ) )
      } ) ();

      /**
       * Expand categories description on "more" button click.
       */
      ( function expandCategoriesOnMoreButtonClick() {

        // Function to check if the element has overflowed
        function isOverflowed( element ) {
          return element.scrollWidth > element.clientWidth;
        }

        /**
         * Update "More" button.
         */
        function updateMoreButton() {
          const lastParagraph = document.querySelector( '.term-description p:last-child' )

          if ( lastParagraph && isOverflowed( lastParagraph ) ) {
            const moreLink = lastParagraph.querySelector( '.toggle-more-less' );

            if ( ! moreLink ) {
              lastParagraph.insertAdjacentHTML( 'beforeend', ' <a href="#" class="toggle-more-less"><strong>meer</strong></a>' )

              const newMoreLink = lastParagraph.querySelector( '.toggle-more-less' )
              newMoreLink.addEventListener( 'click', function ( e ) {
                e.preventDefault()

                lastParagraph.classList.add( 'expanded' )
                this.innerHTML = '' // Optionally change or remove the button after expansion
              } )
            }
          } else if ( lastParagraph ) { // If the paragraph is not overflowing but the "more" link is present, remove it.
            let moreLink = lastParagraph.querySelector( '.toggle-more-less' );

            if ( moreLink ) {
              moreLink.remove();
            }
          }
        }

        // Initial check on page load.
        updateMoreButton();

        // Update the button visibility on window resize.
        window.addEventListener( 'resize', debounce( updateMoreButton, 100 ) );
        document.addEventListener( 'swan_speedsearch_after_category_description_update', updateMoreButton);
      } ) ();

      /**
       * Add "New" sorting button.
       */
      ( function addNewSortingButton() {
        const openMobileFiltersBtn = document.querySelector( '.speedsearch-open-mobile-filters-btn' );
        if ( openMobileFiltersBtn ) {
          openMobileFiltersBtn.insertAdjacentHTML(
              'afterend',
              '<span class="speedsearch-sort-by-new-order-button">nieuw</span>'
          );


          const sortByNewOrderBtn = document.querySelector( '.speedsearch-sort-by-new-order-button' );
          sortByNewOrderBtn.addEventListener( 'click', e => {
            const newestSorting = document.querySelector(
                '.speedsearch-filter[data-name="sort-by"] .speedsearch-filter-fields .speedsearch-filter-field[data-val="newest"]:not(.active)'
            );

            if ( newestSorting ) {
              newestSorting.click();
            }
          } );

          /**
           * Hide or show "sorty by new button" button, depending on the current filters.
           */
          function buttonStateCheck() {
            if ( window.location.search.includes( 'sort-by=newest' ) ) {
              sortByNewOrderBtn.style.display = 'none';
            } else {
              sortByNewOrderBtn.style.display = '';
            }
          }

          buttonStateCheck();

          // Adds misc listeners.

          window.addEventListener( 'popstate', buttonStateCheck );

          /**
           * Monkey-patch to add button state check listeners.
           */
          ( function ( history ) {

                // pushState

                const pushState = history.pushState
                history.pushState = function ( state ) {
                  const result = pushState.apply( history, arguments ); // Change the state first

                  buttonStateCheck()  // Check button state after the state is updated

                  return result
                }

                // replaceState

                const replaceState = history.replaceState
                history.replaceState = function ( state ) {
                  const result = replaceState.apply( history, arguments ); // Change the state first

                  buttonStateCheck()  // Check button state after the state is updated

                  return result
                }
              }
          )( window.history );
        }
      } ) ();
    }
  });
})(jQuery, window, document);

/**
 * Themes settings.
 */
document.addEventListener( "DOMContentLoaded", function() {
  if ( ! window.hasOwnProperty( 'swanTheme' ) ) {
    window.swanTheme = {};
  }

  const form = document.querySelector( '.swan-theme-form' );
  if ( form ) {
    form.addEventListener( 'submit', event => {
      event.preventDefault();
    } );

    /**
     * "Save" click: Sends an AJAX with the settings to the server.
     */
    const submitBtn = document.querySelector( '.swan-theme-setting-save' );
    if ( submitBtn ) {
      submitBtn.addEventListener( 'click', () => {
        const formData = new FormData( form );

        // Sends AJAX with new settings.

        let data = {
          'action':         'swan_settings_save',
          'nonceToken':     swanTheme.nonceToken,
          'notifications1': formData.get( 'notifications-1' ),
          'notifications2': formData.get( 'notifications-2' ),
          'notifications3': formData.get( 'notifications-3' ),
          'notifications4': formData.get( 'notifications-4' ),
          'notifications5': formData.get( 'notifications-5' ),
        };

        let params = {
          method:      'POST',
          credentials: 'same-origin',
          headers:     new Headers( { 'Content-Type': 'application/x-www-form-urlencoded' } ),
          body:        new URLSearchParams( data )
        };

        fetch( ajaxurl, params ).then( response => {
          return response.json();
        } ).then( response => {
          location.reload();
        } );
      } );
    }
  }

  /**
   * Prints out settings save log to the console.
   */
  swanTheme.getDebugData = function() {
    let data = new URLSearchParams( {
      'action':     'swan_get_debug_data',
      'nonceToken': swanTheme.nonceToken,
    } ), params = {
      method:      'POST',
      credentials: 'same-origin',
      headers:     new Headers( { 'Content-Type': 'application/x-www-form-urlencoded' } ),
      body:        data
    };

    fetch( ajaxurl, params ).then( response => {
      return response.json();
    } ).then( response => {
      if ( response.success ) {
        const settingsSaveLog = response.data.debugData;

        console.log( settingsSaveLog );
      }
    } );
  };
} );
